<template>
  <div class="activityList">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>Exhibitor Badge Application</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="operas">
      <div class="tktNum">
        <!-- <span>可申请证件数量：<b style="color:red;">{{ticketNumObj.totalTicketNum}}</b>张，</span> -->
        <span style="padding-right: 20px;">Number of Badges:<b style="color:green;">{{ticketNumObj.submittedTicketNum}}</b></span>
        <el-button type="primary" @click="addCard">Add New</el-button>
        <el-button type="primary" @click="onSubmit('1')" :disabled="Dsave">Save as Draft</el-button>
        <el-button type="primary" @click="onSubmit('')" :disabled="saveBtnStatue">Submit</el-button>
      </div>
      <div class="">
        <!-- <el-button type="primary" @click="getListWarp">Retrieve Badge data of Previous edition</el-button> -->
        <!-- <el-button type="primary" @click="addCard">Add New</el-button> -->
      </div>
      <!-- <el-button type="primary" @click="addCard" :style="buttonStyle">新增</el-button> -->
    </div>
    <el-table
      empty-text='No Data Available'
      :data="tableData"
      style="width: 100%">
      <el-table-column
        prop="tktName"
        label="Name">
      </el-table-column>
      <el-table-column
        prop="tktComName"
        label="Company Name">
      </el-table-column>
      <!-- <el-table-column
        label="头像"
        width="160">
        <template slot-scope="scope">
          <img style="max-height:100px;" :src="scope.row.photo"/>
        </template>
      </el-table-column> -->
      <el-table-column
        prop="tktPassportNo"
        label="ID Number">
      </el-table-column>
      <el-table-column
        prop="tktRank"
        label="Position">
      </el-table-column>
      <el-table-column
        label="State">
        <template slot-scope="scope">
          <span v-if="scope.row.tktSysState == '正常'">Submitted</span>
          <span v-else>Not submitted</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Action"
        width="160">
        <!-- <template slot-scope="scope"  v-if="scope.row.tktIfMakeCard !='1'"> -->
        <template slot-scope="scope"  v-if="scope.row.tktIfMakeCard !='1'">
          <el-button @click="editCard(scope.row)" type="text" size="small">Modify</el-button>
          <el-button @click="deletCard(scope.row)" type="text" size="small" v-if="scope.row.tktIfTreat == false">Delete</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="Previous data" :visible.sync="oldDataDialog" width="60%" center >
      <div style="max-height:600px;overflow: hidden;overflow-y: auto;">
        <el-table
        align="center"
        empty-text='No Data Available'
          :data="oldTableData"
          @selection-change="handleSelectionChange"

          style="width: 100%;">
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
            <el-table-column
              prop="tktName"
              label="Name">
            </el-table-column>
            <el-table-column
              prop="tktComName"
              width="160" 
              label="Company Name">
            </el-table-column>
            <el-table-column
              label="photo"
              width="160" align="center">
              <template slot-scope="scope">
                <img style="max-height:100px;max-width: 100px;text-align: center;" :src="scope.row.photo"/>
              </template>
            </el-table-column>
            <el-table-column
              prop="tktPassportNo"
              label="ID Number">
            </el-table-column>
            <el-table-column
              prop="tktRank"
              label="Position">
            </el-table-column>
            <el-table-column
              prop="tktMobile"
              label="Mobile">
            </el-table-column>

          </el-table>

      </div>
        <!-- <div style="text-align:center;padding:10px 0">
            <el-pagination
            @current-change = 'pageChange'
            :page-size="10"
            layout="prev, pager, next"
            :total="total">
          </el-pagination>
        </div> -->
        <div style="text-align:center;padding-top:30px"><el-button type="primary" @click="saveHist">Save</el-button></div>
      </el-dialog>

  </div>
</template>
<script>
import api from '@/api'
import reg from '@/utils/regExp'
import tools from '../../utils/tools.js';
export default {
  name: 'Card',
  data() {
    return {
      tableData: [],
      ticketNumObj: {},
      buttonStyle: sessionStorage.getItem('buttonStyle') ? JSON.parse(sessionStorage.getItem('buttonStyle')) : {},
      oldDataDialog:false,
      pageSize:'9999999',
      pageCurrent: '1',
      total:0,
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      oldTableData:[],
      selectData:[],
      Dsave: true,
      saveBtnStatue: true
    }
  },
  mounted() {
    this.getTicket()
    this.getticketnum()
  },
  methods: {
    getListWarp(){
      this.oldDataDialog = true
      api.ticketnotthelist({
        exhId: this.ExhID,
        TktIfTheExhibition:'0',
        TktComName:this.userInfo.atrName,
        pageIndex: this.pageCurrent,
        pageSize: this.pageSize,

      }).then(res => {
        if (res.data.code === 200) {
          this.oldTableData = res.data.data.list
          this.total = res.data.data.total
        }

      })
    },
    pageChange(page){
      this.pageCurrent = page.toString()
      this.getListWarp()
    },
        handleSelectionChange(val){
      this.selectData = val
    },
    saveHist(){
      for(var i=0;i<this.selectData.length;i++){
        this.selectData[i].tktComName = this.userInfo.atrName
        this.selectData[i].tktType= ''
      }
      if(this.selectData.length>0){
          api.addtickets({
          exhId: this.ExhID,
          data:this.selectData
        }).then(res => {
          if (res.data.code === 200) {
            this.getTicket()
            this.getticketnum()
            this.$notify({
              title: 'Tip',
              message: res.data.msg,
              type: 'success'
            });
          } else if (res.data.code === 900) {
            // this.$toast.fail('登录超时！')
            this.$notify({
              title: 'error',
              message: res.data.msg,
              type: 'error'
            });
    
          }
          this.oldDataDialog = false
        })
      }else{
        this.$notify({
            title: 'Tip',
            message: 'Please select!',
            type: 'warning'
          });
      }

    },

    getticketnum() {
      api.getticketnum().then(res => {
        if (res.data.code === 200) {
          this.ticketNumObj = res.data.data
          this.overlayshow = false
        }
      })
    },
    addCard() {
      if (this.ticketNumObj.totalTicketNum > this.ticketNumObj.submittedTicketNum) {
        this.$router.push({path: '/addCard', query: {type: 'add'}})
      } else {
        this.$notify({
          title: 'Tip',
          message: 'The number of documents has reached the upper limit',
          type: 'error'
        });
      }
    },
    deletCard(row) {
      this.$confirm('Are you sure you want to delete this document?', 'Tip', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
        center: true
      }).then(() => {
        api.deleteticket({tktID: ''+row.tktID}).then(res => {
          if (res.data.code === 200) {
            this.$notify({
              title: 'success',
              message: 'Delete successful',
              type: 'success'
            });
            this.getTicket()
            this.getticketnum()
          }
        })
      }).catch(() => {});
    },
    resetForm() {
      this.ruleForm={
        tktName: '',
        tktComName: '',
        photo: '',
        tktIDCard: '',
        tktRank: ''
      }
    },
    getTicket() {
      api.ticketlist().then(res => {
        if (res.data.code === 200) {
          this.tableData = res.data.data.list
          this.Dsave = false
          this.saveBtnStatue = false
        }
      })
    },
    editCard(row, type) {
      this.$router.push({path: '/addCard', query: {type: 'edit', tktID: row.tktID}})
    },
    onSubmit(IsCache){
      api.SaveCACTicketSubmitStatus({
       IsCache: IsCache,
      }).then(res => {
        if (res.data.code === 200) {
          this.$notify({
            title: 'Tip',
            message: res.data.eMsg,
            type: 'success'
          });
          this.getTicket()
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.activityList{
  .tktNum{
    span{
      font-size: 14px;
      b{
        font-size: 16px;
        padding: 0 10px;
      }
    }
  }
  .operas{
    text-align: right;
    padding: 20px 0;
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
  .fileParent {
    position: relative;
    img {
      position: absolute;
      width: 60px;
      height: 39px;
      left: 0;
      top: 0;
    }
  }
  .file {
    position: absolute;
    left: 0;
    opacity: 0;
  }
  .cardItem{
      -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      display: flex;
      margin-bottom: 50px;
      padding: 20px;
      border-radius: 10px;
  }
  .cardItem .img{
      width:200px;
      height:200px;
      margin-right: 10px;
      text-align: center;
  }
  .cardItem .img img{
      max-width:100%;
      max-height:100%;
  }
  .rightBox{
    width: 65%;
    font-size:14px;
    position: relative;
    padding: 14px;
    p{
      padding-top:15px;
    }
    .bottom{
        padding-top: 20px;
    }
  }
  
  .mart30{
    padding-top:30px;
  }
  .blue{
    color:#409EFF
  }
  .cards{
    display: flex;
    flex-wrap: wrap;
    >li{
      padding: 0 20px;
      width: 50%
    }
  }
  @media screen and (max-width:540px){
    .cards>li{
      width: 100%;
      padding:0;
      .img{
        width:120px;
        height: auto;
      }
    }
    .rightBox{
      padding:0;
      font-size: 14px;
      >p{
        padding-top:10px;
      }
      .el-button{
        padding:8px 16px;
      }
    }
  }
}
</style>
